import { AppGroup, AppChip, AppSegment } from 'client/ui-building-blocks'

const ChipPreview = () => {
  return (
    <>
      <AppSegment headerProps={{ text: 'Variant', marginBottom: 'small' }}>
        <AppGroup position="center">
          <AppChip text="Success" variant="success" />
          <AppChip text="Info" variant="info" />
          <AppChip text="Warning" variant="warning" />
          <AppChip text="Error" variant="error" />
          <AppChip text="Outlined" variant="outlined" />
          <AppChip text="Blank" variant="blank" />
          <AppChip text="Dark" variant="dark" />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Alignment', marginBottom: 'small' }}>
        <AppChip text="I am in center" centered />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Icon', marginBottom: 'small' }}>
        <AppChip
          variant="dark"
          text="You can close me"
          iconName="CLOSE"
          onIconClick={() => null}
        />
      </AppSegment>
    </>
  )
}

export default ChipPreview
